import React, { FC } from "react";
import { useFormContext } from "react-hook-form";
import { ErrorMessage } from '@hookform/error-message';
import { InputFieldProps } from "./SubscriptionForm";


export const InputField: FC<InputFieldProps> = ({ label, hideLabel = false, name, type = "text", placeholder, validate, required = false, ...rest }) => {
  const { register, formState: { errors } } = useFormContext();
  const errorMessage = errors[name];
  let registerOptions: any = { required };
  if (validate)
    registerOptions.validate = validate;
  return (
    <div className="w-full">
      <label htmlFor="email" className={hideLabel ? "sr-only" : "block text-sm font-medium text-gray-700"}>{label}</label>
      <div className="">
        <input
          type={type}
          className="rounded-none shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300"
          aria-invalid={errorMessage ? "true" : "false"}
          placeholder={hideLabel ? label : placeholder}
          {...register(name, registerOptions)}
          {...rest} />
      </div>
      <ErrorMessage  name={name} render={({ message }) => <p className="mt-2 text-sm text-red-600" id="email-error">{message ? message  : "Error"}</p>} />
    </div>
  );
};
